module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.activeView !== 'video' && _vm.showVideo) ? _c('background-video') : _vm._e(), _vm._v(" "), (_vm.showOverlay) ? _c('color-filter-overlay', {
    staticClass: "overlay--make",
    attrs: {
      "active": _vm.playing
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controlButtons"
  }, [_c('label', [_vm._v("Show (only applies to this page):")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showVideo = !_vm.showVideo
      }
    }
  }, [_vm._v("Video: " + _vm._s(_vm.showVideo))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showOverlay = !_vm.showOverlay
      }
    }
  }, [_vm._v("Overlay: " + _vm._s(_vm.showOverlay))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showConfig = !_vm.showConfig
      }
    }
  }, [_vm._v("Controls: " + _vm._s(_vm.showConfig))])]), _vm._v(" "), _c('nav', [_c('label', [_vm._v("Create Controls")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'meta'
      }
    }
  }, [_vm._v("Publish Options")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'synth'
      }
    }
  }, [_vm._v("Synth")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'scale'
      }
    }
  }, [_vm._v("Scale")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'video'
      }
    }
  }, [_vm._v("Background Video")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'overlay'
      }
    }
  }, [_vm._v("Overlay")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'mutations'
      }
    }
  }, [_vm._v("Mutations")])]), _vm._v(" "), (_vm.activeView === 'meta' && _vm.showConfig) ? _c('meta-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'synth' && _vm.showConfig) ? _c('synth-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'scale' && _vm.showConfig) ? _c('scale-config', {
    attrs: {
      "playing": _vm.playing
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeView === 'video' && _vm.showConfig) ? _c('video-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'overlay' && _vm.showConfig) ? _c('overlay-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'mutations' && _vm.showConfig) ? _c('mutation-config') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7e51c80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Make.vue
// module id = 293
// module chunks = 1